import {
  INSIGHTS_REQUEST,
  INSIGHTS_SUCCESS,
  INSIGHTS_FAILURE,
  UPDATE_INSIGHT_REQUEST,
  UPDATE_INSIGHT_SUCCESS,
  UPDATE_INSIGHT_FAILURE,
} from "../types/insights.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
  updateLoading: false,
};

const InsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSIGHTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case INSIGHTS_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case INSIGHTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPDATE_INSIGHT_REQUEST:
      return { ...state, updateLoading: true };
    case UPDATE_INSIGHT_SUCCESS:
      return { ...state, updateLoading: false };
    case UPDATE_INSIGHT_FAILURE:
      return { ...state, updateLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default InsightsReducer;
